// razorpay-axios.js
//
// Dedicated axios instance for the Razorpay order/verify calls. Kept separate
// from ../../../axios-url.js (which points at the real HRMS/POS backend)
// because those two routes don't exist there yet — this points at the local
// throwaway .NET test API (c:\work\Razorpay, POST /create-order and
// POST /verify-payment) standing in for them. Once the real backend adds
// equivalent routes, swap this baseURL (or drop this file and use the shared
// axios-url.js instance instead).
import axios from 'axios';

const razorpayAxios = axios.create({
    baseURL: 'http://localhost:5000',
    headers: {
        'Content-Type': 'application/json',
    },
});

export default razorpayAxios;
